import { Alert } from 'antd'
import { useTranslation } from 'react-i18next'

export const QrApprovedNotice = () => {
  const { t } = useTranslation()

  return (
    <Alert
      showIcon
      type="success"
      title={t('auth.qrSignIn.approved.title')}
      description={t('auth.qrSignIn.approved.description')}
    />
  )
}
